module.exports = __webpack_public_path__ + "static/img/product_five.bfd2920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_five.png
// module id = 1EwM
// module chunks = 1